/* @flow */
import fields from './fields';
import fieldsReducer from './reducer';

export {
  fields,
  fieldsReducer,
};



// WEBPACK FOOTER //
// ./src/common/lib/redux-fields/index.js